// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const NotificationHandler = () => {
//   const navigate = useNavigate();
//   const isAuthenticated = !!localStorage.getItem("username");

//   useEffect(() => {
//     navigator.serviceWorker.addEventListener("message", (event) => {
//       if (event.data && event.data.type === "NOTIFICATION_CLICKED") {
//         console.log("🔔 Notification Clicked - Redirecting...");

//         if (isAuthenticated) {
//           navigate("/dashboard"); // Redirect logged-in user
//         } else {
//           navigate("/login"); // Redirect guest
//         }
//       }
//     });
//   }, [isAuthenticated, navigate]);

//   return null; // This component does not render anything
// };

// export default NotificationHandler;

import { useEffect } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../Utils/fcm";  // ✅ make sure path is correct

function NotificationHandler() {
  useEffect(() => {
    if (!messaging) return;

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Notification Received:", payload);
      alert(payload.notification?.body); // 🔔 replace later with Snackbar/Toast
    });

    return () => unsubscribe();
  }, []);

  return null;
}

export default NotificationHandler;


